import React, { FC } from "react";
import { ActionsGroup, DialogTitle, IconButton } from "@evergis/ui";
import { ResourceTypeLink } from "@evergis/api";

import { useDialogInfo } from "../../../../hooks/useDialogs";
import { useTitleText } from "../hooks/useTitleText";

export const Title: FC<{ type?: ResourceTypeLink }> = ({ type }) => {
  const titleText = useTitleText(type);
  const { closeDialog } = useDialogInfo(true);

  return (
    <>
      <DialogTitle>
        <ActionsGroup>{titleText}</ActionsGroup>
        <ActionsGroup>
          <IconButton kind={"close"} onClick={closeDialog} />
        </ActionsGroup>
      </DialogTitle>
    </>
  );
};
